import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';

const PageBanner = ({ rendering }) => (
  <section className='single-col-wide'>
    <Placeholder name="jss-page-banner" rendering={rendering} />
  </section>
);

export default PageBanner;